import { IngredientsRoot, IngredientsContainer, IngredientRow, Title } from './RecipeDetailIngredients.styles'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { useTranslation } from 'hooks/useTranslation'
import { TranslationKeys } from 'locales/translationKeys'

export type IngredientType = {
  label: TranslationKeys
  description: TranslationKeys
}

export type RecipeDetailIngredientsProps = { 
  title: TranslationKeys
  rows: IngredientType[]
  condensed?: boolean
}

export const RecipeDetailIngredients = ({ title, rows, condensed = false }: RecipeDetailIngredientsProps) => {
  const { t } = useTranslation()

  return (
    <IngredientsRoot>
      <IngredientsContainer>
        <Title>{t(title)}</Title>
        <Stack direction='column' gap='0' width='fullWidth'>
          {
            rows.map((row, index) => (
              <IngredientRow key={index}>
                <Text transform={condensed ? 'uppercase' : 'uppercase'} font={condensed ? 'label' : 'primary'} weight='semiBold' size='headline'>{t(row.label)}</Text>
                <Text>
                  {t(row.description)}
                </Text>
              </IngredientRow>
            ))
          }
        </Stack>
      </IngredientsContainer>
    </IngredientsRoot>
  )
}

RecipeDetailIngredients.displayName = 'RecipeDetailIngredients'
